window.objRef = null;
window.currentCountyOriginal = null;
window.currentSchoolOriginal = null;

window.simplemaps = {

    initializeScripts: async (objRef) =>
    {
        await InitializeSimpleMaps(objRef);

        setTimeout(() =>
        {
            simplemaps_custommap.pulse('9000');
        }, 2000);

        
        
    },
    getShowingCounties: async () =>
    {
        var state_specific = simplemaps_custommap_mapdata.state_specific;

        var counties = [];
        for (var key in state_specific)
        {
            var county = state_specific[key];
            county.mapId = key;
            counties.push(county);
        }
        return counties;
    },
    getShowingDistricts: async (mapId) =>
    {
        var districts = [];
        var districtMapIds = simplemaps_custommap_mapinfo.mappings[mapId].states;
        for (var districtMapId of districtMapIds)
        {
            var district = simplemaps_custommap_mapdata.state_specific[districtMapId];
            if (district)
            {
                district.mapId = districtMapId;
                districts.push(district);
            }
        }

        return districts;
    },
    getShowingSchools: async (mapId) =>
    {
        var schools = simplemaps_custommap_mapinfo.districts[mapId].locations;
        var returnSchools = [];
        for (var key in schools)
        {
            var school = schools[key];
            school.mapId = key;
            returnSchools.push(school);
        }

        return returnSchools;

        //for (var school in schools)
        //{
        //    if (school)
        //    {
        //        school.mapId = school;
        //        districts.push(district);
        //    }
        //}
        //return simplemaps_custommap_mapdata.locations;
    },
    setInactiveSchool: async () =>
    {
        if (window.currentSchoolOriginal)
        {
            window.currentSchoolOriginal.dispatchEvent(new Event("mouseout", { bubbles: true }));
            window.currentSchoolOriginal = null;
        }
    },
    setInactiveElement: async () =>
    {
        if (window.currentCountyOriginal)
        {
            window.currentCountyOriginal.dispatchEvent(new Event("mouseout", { bubbles: true }));
            window.currentCountyOriginal = null;
        }
    },
    setActiveElement: async (mapId) =>
    {

        //setInactiveElement();

        var element = document.getElementsByClassName("sm_state_" + mapId)[0];
        window.currentCountyOriginal = element;
        if (element)
        {
            element.dispatchEvent(new Event("mouseover", { bubbles: true }));
            simplemaps_custommap.popup('state', mapId);
        } else
        {
            console.warn("State element not found.");
        }


    },
    setActiveSchool: async (mapId) =>
    {

        //setInactiveSchool();

        var element = document.getElementsByClassName("sm_location_" + mapId)[0];
        window.currentSchoolOriginal = element;
        if (element)
        {
            element.dispatchEvent(new Event("mouseover", { bubbles: true }));
            simplemaps_custommap.popup('location', mapId);
            simplemaps_custommap.pulse(mapId);
        } else
        {
            //console.warn("Location element not found.");
        }


    },
    selectCounty: async (mapId) =>
    {
        var element = document.getElementsByClassName("sm_state_" + mapId)[0];
        if (element)
        {
            element.dispatchEvent(new Event("click", { bubbles: true }));
        } else
        {
            console.warn("State element not found.");
        }

    },
    selectDistrict: async (mapId) =>
    {
        var element = document.getElementsByClassName("sm_state_" + mapId)[0];
        if (element)
        {
            element.dispatchEvent(new Event("click", { bubbles: true }));
        } else
        {
            console.warn("State element not found.");
        }

    },
    selectSchool: async (mapId) =>
    {
        var element = document.getElementsByClassName("sm_location_" + mapId)[0];
        if (element)
        {
            element.dispatchEvent(new Event("click", { bubbles: true }));
        } else
        {
            console.warn("State element not found.");
        }

    },
    back: async () =>
    {
        var mapOuter = document.getElementById("map_outer");
        //get rect element types from mapOuter
        var backButton = mapOuter.getElementsByTagName("path")[0];
        if (backButton != null)
        {
            backButton.dispatchEvent(new Event("click", { bubbles: true }));
        }
    }

}

async function InitializeSimpleMaps(objRef)
{
    window.objRef = objRef;

    await loadScript("/js/location/custom/mapdata.js");
    await loadScript("/js/location/custom/custommap.js");
    await loadScript("/js/location/custom/link.js");

}

function loadScript(src)
{
    return new Promise((resolve, reject) =>
    {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}


